import React from 'react';
export const OCRContainer = ({ children, hidden }) => {
    return (React.createElement("div", { className: "fixed w-screen h-screen top-0 left-0 z-[1001] bg-white pointer-events-auto ocr-shared-container", ...(hidden ? { hidden: true } : {}) }, children));
};
export const OCRProgress = () => {
    return (React.createElement("div", { className: "ocr-shared-overlay" },
        React.createElement("div", { className: "ocr-circle" },
            React.createElement("span", { className: "ocr-inner-circle" }))));
};
